import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import productTagUseCaseV2 from '../../factories/v2/productTag';

export const REACT_QUERY_LIST_TAGS_V2_KEY = 'listTagsV2';
export const REACT_QUERY_GET_TAG_V2_KEY = 'getTagV2';
export const REACT_QUERY_GET_TAG_DETAIL_V2_KEY = 'getTagDetailV2';

/**
 * List tags for autocomplete. Variables: { search, limit }.
 */
export const useListTagsV2 = (variables = {}, options = {}) => {
  return useQuery({
    queryKey: [REACT_QUERY_LIST_TAGS_V2_KEY, variables],
    queryFn: () => productTagUseCaseV2.list(variables),
    ...options,
  });
};

export const useGetTagBySlugV2 = (slug, options = {}) => {
  return useQuery({
    queryKey: [REACT_QUERY_GET_TAG_V2_KEY, slug],
    queryFn: () => productTagUseCaseV2.getBySlug(slug),
    enabled: !!slug,
    ...options,
  });
};

export const useGetTagDetailV2 = (slug, options = {}) => {
  return useQuery({
    queryKey: [REACT_QUERY_GET_TAG_DETAIL_V2_KEY, slug],
    queryFn: () => productTagUseCaseV2.getDetail(slug),
    enabled: !!slug,
    ...options,
  });
};

const invalidateTagQueries = (queryClient) => {
  queryClient.invalidateQueries({ queryKey: [REACT_QUERY_LIST_TAGS_V2_KEY] });
  queryClient.invalidateQueries({ queryKey: [REACT_QUERY_GET_TAG_V2_KEY] });
  queryClient.invalidateQueries({ queryKey: [REACT_QUERY_GET_TAG_DETAIL_V2_KEY] });
};

export const useCreateTagV2 = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: productTagUseCaseV2.create,
    onSuccess: () => invalidateTagQueries(queryClient),
    onError: (error) => {
      console.error('Failed to create tag:', error);
    },
  });
};

export const useUpdateTagV2 = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: productTagUseCaseV2.update,
    onSuccess: () => invalidateTagQueries(queryClient),
    onError: (error) => {
      console.error('Failed to update tag:', error);
    },
  });
};

export const useDeleteTagV2 = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: productTagUseCaseV2.remove,
    onSuccess: () => invalidateTagQueries(queryClient),
    onError: (error) => {
      console.error('Failed to delete tag:', error);
    },
  });
};
